import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const ArrowInSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        d="M4.3288 9.94279L3.44229 9.96422L9.99593 3.42858V4.30114C9.99201 4.43514 10.015 4.56855 10.0636 4.69349C10.1122 4.81843 10.1853 4.93236 10.2788 5.02852C10.3722 5.12468 10.4839 5.20113 10.6074 5.25333C10.7309 5.30554 10.8637 5.33243 10.9978 5.33243C11.1318 5.33243 11.2646 5.30554 11.3881 5.25333C11.5116 5.20113 11.6233 5.12468 11.7167 5.02852C11.8102 4.93236 11.8833 4.81843 11.9319 4.69349C11.9805 4.56855 12.0035 4.43514 11.9996 4.30114L11.9919 1.00118C11.9921 0.868924 11.9661 0.737934 11.9153 0.615805C11.8645 0.493676 11.79 0.382839 11.696 0.289716C11.6021 0.196594 11.4906 0.12304 11.368 0.073317C11.2454 0.0235941 11.1142 -0.00130842 10.9819 5.29493e-05L7.64934 0.0506238C7.38319 0.05392 7.12924 0.162783 6.94337 0.353264C6.75751 0.543745 6.65494 0.800241 6.65824 1.06633C6.66153 1.33241 6.77042 1.58629 6.96096 1.77211C7.15149 1.95793 7.40805 2.06047 7.6742 2.05717L8.56071 2.03574L2.00707 8.57138V7.69882C2.00696 7.43273 1.90112 7.17759 1.71284 6.98952C1.52456 6.80145 1.26926 6.69586 1.00311 6.69597C0.736954 6.69608 0.481745 6.8019 0.293626 6.99013C0.105507 7.17836 -0.000113601 7.43359 9.16913e-08 7.69967L0.00771631 10.9996C0.00759018 11.1321 0.0338112 11.2633 0.0848546 11.3856C0.135898 11.5078 0.210745 11.6187 0.305043 11.7118C0.399341 11.8049 0.511208 11.8783 0.634139 11.9277C0.75707 11.9772 0.888611 12.0017 1.02111 11.9999L4.35366 11.9493C4.61981 11.946 4.87376 11.8372 5.05963 11.6467C5.24549 11.4562 5.34806 11.1997 5.34477 10.9336C5.34147 10.6675 5.23258 10.4137 5.04205 10.2279C4.85151 10.042 4.59495 9.93949 4.3288 9.94279Z"
        fill={fill}
      />
    </svg>
  </span>
);

export default ArrowInSVG;
